import { Component, OnInit } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { LogoutService } from '@cutting/main/shared/services/logout.service';
import { UserService } from '@cutting/main/shared/services/user.service';
import { CuttingClient, LegacyDialogsService } from 'cloud-shared-lib';
import { EMPTY, Observable } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { DeleteAccountDialogComponent } from './delete-account-dialog/delete-account-dialog.component';

@Component({
  selector: 'cutting-delete-account',
  templateUrl: './delete-account.component.html',
})
export class DeleteAccountComponent implements OnInit {
  client: CuttingClient;
  user$: Observable<CuttingClient>;
  actions$: Observable<unknown>;

  constructor(
    private dialogService: LegacyDialogsService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private logoutService: LogoutService
  ) {}

  ngOnInit(): void {
    this.user$ = this.userService.getClientExtended().pipe(
      tap(client => {
        this.client = client;
      })
    );
  }

  onDeleteAccount(): void {
    this.actions$ = this.dialogService
      .component(DeleteAccountDialogComponent, {
        client: this.client,
      })
      .pipe(
        filter(result => result),
        switchMap(() => this.userService.deleteAccount(this.client.id)),
        tap(() => {
          this.logoutService.logout();
          this.snackBar.open($localize`Ваш аккаунт успешно удален`);
        }),
        catchError(() => {
          this.snackBar.open($localize`Не удалось удалить аккаунт`);
          return EMPTY;
        })
      );
  }
}
